import lax from 'lax.js';

export default function() {
  lax.init();

  lax.addDriver('scrollY', function () {
    return window.scrollY;
  });

  lax.addElements('.parallax', {
    scrollY: {
      translateY: [
        ["elInY", "elCenterY", "elOutY"],
        {
          998: [0, 0, 0],
          1400: ['screenHeight/-10', 0, 'screenHeight/10'],
        },
      ]
    }
  });
}
